module.exports = __webpack_public_path__ + "assets/gateio-white.31c0eb26.svg";